const SolutionCTAUndefined = (props) => {
  return (
    <div className="section-spacing-80 no-padding-top world-bg">
      <div className="width-600 margin-auto ntuna-cta-container">
        <ul className="page-sections-container">
          <li className="page-section-item center">
            <h2 className="page-section-title ntuna-text-fill">
              {props.ctaTitle}
            </h2>
            <p>
              Whatsapp or give us a call on{" "}
              <a href="tel:+256702096666">+256-702-096-666</a>,{" "}
              <a href="tel:+13153470333">+1-315-347-0333</a> and{" "}
              <a href="tel:+256771001999">+256-771-001-999</a> or send us an
              email to <a href="mailto:ready@ntuna.com">ready@ntuna.com.</a>
            </p>
            <div className="width-300 margin-auto">
              {" "}
              <a
                href={props.CTAlink}
                target="_blank"
                rel="noopener noreferrer"
                className="maincta button boldTitle"
              >
                <span>{props.CTAtext}</span>
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SolutionCTAUndefined;
